import {defineMessages} from "@project/i18n";

export const userFieldLabelIds = {
  active: "fields.user.active",
  bio: "fields.user.bio",
  department: "fields.user.department",
  email: "fields.user.email",
  name: "fields.user.name",
  role: "fields.user.role",
  seniority: "fields.user.seniority",
} as const;

export const userFieldMessages = defineMessages({
  active: {
    id: "fields.user.active",
    defaultMessage: "Active",
    description: "User field label for active status",
  },
  bio: {
    id: "fields.user.bio",
    defaultMessage: "Bio",
    description: "User field label for bio",
  },
  department: {
    id: "fields.user.department",
    defaultMessage: "Department",
    description: "User field label for department",
  },
  email: {
    id: "fields.user.email",
    defaultMessage: "Email",
    description: "User field label for email",
  },
  name: {
    id: "fields.user.name",
    defaultMessage: "Full name",
    description: "User field label for full name",
  },
  role: {
    id: "fields.user.role",
    defaultMessage: "Role",
    description: "User field label for role",
  },
  seniority: {
    id: "fields.user.seniority",
    defaultMessage: "Seniority Level",
    description: "User field label for seniority level",
  },
});
